module.exports = __webpack_public_path__ + "static/img/rm1.ae35939.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rm1.png
// module id = gUie
// module chunks = 1